import Header from "../Header/Header"
import ShortenURL from "../ShortenURL/ShortenURL"
import Statistics from "../Statistics/Statistics"
import Cto from "../Cto/Cto"

const Home = () => {
  return (
    <>
      <Header />
      <ShortenURL />
      <Statistics />
      <Cto />
    </>
  )
}

export default Home
